import { template as template_4fdd250a0c314d0db93ab9a560e0ba78 } from "@ember/template-compiler";
import { action } from '@ember/object';
import { modifier } from 'ember-modifier';
import AttachTooltip from 'ember-attacher/components/attach-tooltip';
import Component from '@glimmer/component';
import SpdsCheckbox from 'ember-simplepractice/components/spds/input/checkbox';
export default class RequestClinicianSearchFiltersFilterCheckboxLine extends Component {
    get checkboxId() {
        let kind = String(this.args.kind ?? '').trim();
        let optionId = String(this.args.optionId ?? '').trim();
        return `clinician-search-filter-${kind}-${optionId}`;
    }
    get disabledHintId() {
        let kind = String(this.args.kind ?? '').trim();
        let optionId = String(this.args.optionId ?? '').trim();
        if (!kind || optionId === '' || !this.args.disabled || !this.args.title) {
            return null;
        }
        return `clinician-search-filter-${kind}-${optionId}-disabled-hint`;
    }
    setupInputA11y = modifier((element)=>{
        let input = element.querySelector('input');
        if (!input) {
            return;
        }
        if (this.disabledHintId) {
            input.setAttribute('aria-describedby', this.disabledHintId);
        } else {
            input.removeAttribute('aria-describedby');
        }
        let ariaLabel = String(this.args.ariaLabel ?? '').trim();
        if (ariaLabel) {
            input.setAttribute('aria-label', ariaLabel);
        } else {
            input.removeAttribute('aria-label');
        }
    });
    @action
    handleClick({ event }) {
        this.args.onChange?.(event);
    }
    static{
        template_4fdd250a0c314d0db93ab9a560e0ba78(`
    <li
      class="filter-checkbox-line"
      data-test-clinician-search-filter-option-doc-count={{@docCount}}
    >
      <SpdsCheckbox
        class="filter-checkbox-row"
        @id={{this.checkboxId}}
        @checked={{@checked}}
        @disabled={{@disabled}}
        @onClick={{this.handleClick}}
        {{this.setupInputA11y}}
      >
        <:label>
          <span class="filter-checkbox-text">
            <span class="filter-option-text-content">{{yield}}</span>
            {{#if this.disabledHintId}}
              <span id={{this.disabledHintId}} class="visually-hidden">{{@title}}</span>
            {{/if}}
            {{#if @title}}
              <AttachTooltip
                @placement="right"
                @class="tooltip align-left filter-disabled-tooltip-popover"
              >
                {{@title}}
              </AttachTooltip>
            {{/if}}
          </span>
        </:label>
      </SpdsCheckbox>
    </li>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
